import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import MoreIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import DotIndicator from '@wix/da-ds/pkg/Indicators/DotIndicator';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import BetaBadge from '@wix/da-ds/pkg/BetaBadge';
import IconButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenu';
import ConditionalTooltip from '../../lego/ConditionalTooltip';
import s from './NetworkBarItem.scss';
const NetworkBarItem = ({ children, tooltipContent, isCollapsed = false, className, linkClassName, iconClassName, isSelected, url, tabIndex, biData, menuItems, menuBiData, hasNewContent, betaBadge, icon, menuClassName, showTooltip = true, isTaller, onClick, id, 'aria-label': ariaLabel, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded })=>{
    const { t } = useTranslation();
    const [isActionsDropdownOpen, setActionsDropdownOpen] = useState(false);
    const toggleDropdown = useCallback(()=>setActionsDropdownOpen((isOpen)=>!isOpen), []);
    return /*#__PURE__*/ React.createElement(ConditionalTooltip, {
        tooltipContent: tooltipContent,
        showTooltip: showTooltip && isCollapsed
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isSelected && s['selected'], isCollapsed && s['collapsed'], isActionsDropdownOpen && s['actions-open'], menuItems && s['with-actions'], (url || onClick) && s['clickable'], isTaller && s['taller'], className)
    }, /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        id: id,
        href: url,
        className: classnames(s['item-link'], linkClassName),
        tabIndex: tabIndex,
        biData: biData,
        onClick: onClick,
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['icon'], iconClassName)
    }, icon, hasNewContent && /*#__PURE__*/ React.createElement(DotIndicator, {
        color: "red",
        className: s['new-indicator']
    })), !isCollapsed && children), !isCollapsed && menuItems && /*#__PURE__*/ React.createElement(IconButtonWithContextMenu, {
        className: classnames(s['actions'], menuClassName),
        contextMenuClassName: s['menu'],
        popperClassName: "networkbar-group-dropdown",
        withButton: true,
        noIconHoverEffect: true,
        items: menuItems,
        onToggle: toggleDropdown,
        isInPopup: true,
        usePortal: true,
        "aria-label": t('networkBar.groups.actions.moreActions'),
        biData: isActionsDropdownOpen ? undefined : menuBiData
    }, /*#__PURE__*/ React.createElement(MoreIcon, {
        disableDefaultColors: true
    })), !isCollapsed && betaBadge && /*#__PURE__*/ React.createElement(BetaBadge, {
        className: s['beta-badge'],
        badgeType: betaBadge,
        variant: "small"
    })));
};
NetworkBarItem.displayName = 'NetworkBarItem';
export default NetworkBarItem;
